var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbiotic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1680 617",
    preserveAspectRatio: "xMinYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 617,
    fill: "#C0FD5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.043 239H412.365V258.592H310.657V282.758H411.913V379H291V359.408H392.299V337.283H291.043V239ZM392.299 317.691V302.35H310.657V317.691H392.299ZM438.022 239H457.637V305.278H546.719V239H566.334V324.87H511.985V379H492.371V324.87H438.022V239ZM593.217 239H721.529V379H701.914V258.592H668.108V321.449H648.493V258.592H612.832V379H593.217V239ZM747.595 239H871.82V379H747.595V239ZM767.21 258.592V299.85L852.206 299.85V258.592H767.21ZM852.206 319.442L767.21 319.442V359.408H852.206V319.442ZM903.069 379V239H922.684V379H903.069ZM953.933 239H1078.16V379H953.933V239ZM973.547 258.592V359.408H1058.54V258.592H973.547ZM1143.24 258.592H1097.77V239H1206.47V258.592H1162.86V379H1143.24V258.592ZM1231.08 379V239H1250.7V379H1231.08ZM1274.58 239H1389V258.592H1294.2V359.408H1389V379H1274.58V239Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbiotic);
export default __webpack_public_path__ + "static/media/symbiotic.31f111bff212ae904ffebe2e250aaef3.svg";
export { ForwardRef as ReactComponent };